import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import * as actionTypes from "../../redux/actionTypes";
import swal from "sweetalert";
import { Navbar } from "../../Components/Navbar";
import "./conventional.css";
import switchModes from "../../assets/switchMode.svg";
import filter from "../../assets/filter.svg";
import hide from "../../assets/hide.svg";
import trash from "../../assets/trash.svg";
import share from "../../assets/share.svg";
import more from "../../assets/more.svg";
import adjustment from "../../assets/adjustment.svg";
import { Submit } from "../../Components/Button";
import plus from "../../assets/plus.svg";
import Filter from "../../Components/Filter";
import BasicTable from "../../Components/Table/BasicTable";
import DeleteSelected from "../../Components/deleteSelected/DeleteSelected";
import DeletedFile from "../../Components/deletedItems/DeletedFile";
import PopulateFs from "../../Components/populateFs/PopulateFs";
import ExpandLedger from "../../Components/expandLedger/ExpandLedger";
import AddLedger from "../../Components/addLedger/AddLedger";
import SwitchMode from "../../Components/switchMode/SwitchMode";
import AddGrouping from "../../Components/AddGrouping/AddGrouping";
import Confirmation from "../../Components/confirmationMenu/confirmationMenu";
import ShareScreen from "../../Components/shareScreen/ShareScreen";
import { socket } from "../../services/socket/socket";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
// import ConfirmDeleteModal from "./ConfirmDeleteModal";
import SuccessPopup from "../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../myfin_v2/elements/ErrorPopup";
// import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import folder from "../../assets/folder.svg";
import Snackbar from "@mui/material/Snackbar";
import { AccessProjectContext } from "../../helper/DarkModeContext";
import AssignValuesData from "../setupProject/AssignValuesData";
import ProgressBar from "@ramonak/react-progress-bar";
import { Alert } from "@mui/material";
import DeleteDuplicate from "../../Components/deletedItems/DeleteDuplicate";
import { useMemo } from "react";
import { column } from "../../Components/Table/column";
import { fetchConventionalMode, deleteLineItems } from "../../redux/actions/TemplateTabs/actionCM";
import { getProfile} from "../../services/api/apiHandler";
import { retranslateFS, exportTranslateFS, getMappingDetails } from "../../WorkSpace/Components/ApiServices/apiHandler";
import CommonProgressBar from "../../Components/Common/ProgressBar";
import { fetchTTBSData } from "../../redux/actions/TemplateTabs/actionBS";
import { fetchTTPNLData } from "../../redux/actions/TemplateTabs/actionPNL";
import { fetchTTGroupData } from "../../redux/actions/TemplateTabs/actionGrouping";
import { toggleCheckYearly } from "../../redux/actions/TemplateTabs/actionDragSelector";
// import Stack from '@mui/material/core/Stack';
// import Button from '@mui/material/Button';
// import Snackbar from "@material-ui/core/Snackbar";
// import MuiAlert from '@mui/material/lab/Alert`';
// import Example from '../../Components/reactTable/Table'
// import App from '../../Components/ReactTable/Table'

import commoncss from "../../myfin_v2/css/common.module.css"
import Sidebar from "../../myfin_v2/elements/Sidebar"
import buttoncss from "../../myfin_v2/css/button.module.css";
import bookclosuretbcss from "../../myfin_v2/css/bookclosuretb.module.css";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as DeleteIcon } from "../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as EditIcon } from "../../myfin_v2/assets/icons/editPri.svg";
import { ReactComponent as RecycleBinIcon } from "../../myfin_v2/assets/icons/recycleBin.svg";
import {ReactComponent as ExportIcon } from "../../myfin_v2/assets/icons/export.svg";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import ToggleButton from "../../myfin_v2/elements/ToggleButton";
import { Button } from "../../myfin_v2/elements/Button";
import editcss from "../../myfin_v2/css/editTranslation.module.css";
import Modal from "../../../src/myfin_v2/elements/Modal";
import modalcss from "../../../src/myfin_v2/css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../myfin_v2/assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as DropdownIcon } from "../../myfin_v2/assets/icons/down-arrow.svg";
import { ReactComponent as CalendarIcon } from "../../myfin_v2/assets/icons/calender.svg";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 620,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const totalDiff = {
  color: "#e65308",
  fontWeight: "bold",
  marginLeft: "35px",
};
const Conventional = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const ws_id = localStorage.getItem('ws_id');
  let history = useHistory();
  const dispatch = useDispatch();
  const tableData = useSelector(
    (initialState) => initialState.reducer.tableData
  );
  const filterData = useSelector((initialState) => initialState.reducer.filter);
  // const TB_ID = useSelector((initialState) => initialState.reducer.tb_id);
  const R_TB_ID = useSelector((initialState) => initialState.reducer.tb_id);
  const { multiSelectedRows, checkYearly } = useSelector((state) => state.selectedDragReducer);
  const multiSelectedRows_ = useMemo(() => multiSelectedRows, [multiSelectedRows])
  const [editTranslation, setEditTranslation] = useState(false);
  const LOCAL_TB_ID = localStorage.getItem("tb_id");
  let TB_ID = R_TB_ID ? R_TB_ID : LOCAL_TB_ID;
  const grouping = useSelector((initialState) => initialState.reducer.grouping);
  const conventionMode = useSelector((state) => state.ConventionModeReducer);
  const [state, setstate] = useState([
    { column: "", select: "", change: "", startAmount: "", endAmount: "" },
  ]);
  const [filterRow, setFilterRow] = useState([]);
  const [totalRow, setTotalRow] = useState([]);
  const [totalFilter, setTotalFilter] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [object, setObject] = useState({});
  const [select, setSelect] = useState({});
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deletedMenu, setDeleteMenu] = useState(false);
  const [populateFs, setPopulateFs] = useState(false);
  const [switchMode, setSwitchMode] = useState(false);
  const [addLedger, setAddLedger] = useState(false);
  const [expandLedger, setExpandLedger] = useState(false);
  const [addLedgerAbove, setAddLedgerAbove] = useState(false);
  const [addLedgerBelow, setAddLedgerBelow] = useState(false);
  const [otherGrouping, setOtherGrouping] = useState(grouping);
  const [confirmation, setConfirmation] = useState(false);
  const [addGrouping, setAddGrouping] = useState(false);
  const [confirmationMenu, setConfirmationMenu] = useState();
  const [render, setRender] = useState("");
  // const [filterObject,SetFilterObject]= useState([])
  const [confirmfilClose, SetConfirmFilClose] = useState(false);
  const [hideItems, SetHideItems] = useState(false);
  const [multiOptions, SetMultiOptions] = useState("");
  const [newSg, SetNewSg] = useState();
  const [shareScreen, SetShareScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const projectId = useParams();
  const project_id = projectId.pid || localStorage.getItem("project_id");
  const tb_id = localStorage.getItem("tb_id");
  const [tb_upload, uploadTb] = useState(false);
  const [deleteRow, setDeleteRow] = useState(false);
  const [hiddenFilter, setHiddenFilter] = useState([]);
  const auth = localStorage.getItem("auth_token");
  const [openCurrency, setOpenCurrency] = useState(false);
  const [updateRows, setUpdateRows] = useState(false);
  const [showAssignValues, setAssignValues] = useState(false);
  
  const { access, setAccess } = useContext(AccessProjectContext);
  const [fileUpload, setFileUpload] = useState("");
  const [type, setType] = useState("");
  const [headerdata, setHeaders] = useState([]);
  const [info, setinfo] = useState([]);
  const [index, setIndex] = useState("");
  const [countdata, getDataCount] = useState("");
  const [activeTab, setActiveTab] = useState("Notes");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorData, setErrorData] = useState(null);
  const [updateTabs, setUpdateTabs] = useState(false);
  const [functionalCurrency, setFunctionalCurrency] = useState("");
  const [currentFinancialYear, setCurrentFinancialYear] = useState("");
  const [previousFinancialYear, setPreviousFinancialYear] = useState("");
  const [presetName, setPresetName] = useState("");
  const [company, setCompany] = useState("");
  const [natureOfCompany, setNatureOfCompany] = useState("");
  const [gaap, setGaap] = useState("");
  const [comparativeYearLabel, setComparativeYearLabel] = useState("");
  const [hasTranslatedFS, setHasTranslatedFS] = useState(false);
  const [openDuplicateModal, setDuplicateModal] = useState(false);
  const handleExportTranslation = async () => {
  try {
    const project_id = localStorage.getItem("project_id");

    const response = await exportTranslateFS(project_id);

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Translation_Workings.xlsx");

    document.body.appendChild(link);
    link.click();
    link.remove();

    toast.success("File downloaded successfully");
  } catch (error) {
    toast.error("Export failed");
  }
};
  const [duplicateItems, setDuplicateItems] = useState([]);
  const [filterEnable, setFilterEnable] = useState(false);
  const [interimReporting, setInterimReporting] = useState(false);
  const [translationData, setTranslationData] = useState({
  reportingCurrency: "",
  currentYearOpeningRate: "",
  currentYearClosingRate: "",
  currentYearAverageRate: "",
  previousYearOpeningRate: "",
  previousYearClosingRate: "",
  previousYearAverageRate: "",
  comparativeOpeningRate: "",
  comparativeClosingRate: "",
  comparativeAverageRate: "",
});
const handleSelectCurrency = (value) => {
  setTranslationData((prev) => ({
    ...prev,
    reportingCurrency: value,
  }));

  setOpenCurrency(false);
};
const handleSaveTranslation = async () => {
  try {
    const body = {
      reportingCurrency: translationData.reportingCurrency,
      translateFS: {
        currentYearOpeningRate: Number(translationData.currentYearOpeningRate),
        currentYearClosingRate: Number(translationData.currentYearClosingRate),
        currentYearAverageRate: Number(translationData.currentYearAverageRate),
        previousYearOpeningRate: Number(translationData.previousYearOpeningRate),
        previousYearClosingRate: Number(translationData.previousYearClosingRate),
        previousYearAverageRate: Number(translationData.previousYearAverageRate),
        ...(interimReporting && (translationData.comparativeOpeningRate !== "" ||
        translationData.comparativeClosingRate !== "" ||
        translationData.comparativeAverageRate !== "")
          ? {
              comparativeOpeningRate: Number(translationData.comparativeOpeningRate),
              comparativeClosingRate: Number(translationData.comparativeClosingRate),
              comparativeAverageRate: Number(translationData.comparativeAverageRate),
            }
          : {}),
      },
    };

    await retranslateFS(project_id, body);

    setSuccessMessage("Translation updated successfully");
    setShowSuccessPopup(true);
  } catch (error) {
    setErrorData({
      title: "Error",
      message: "Something went wrong"
    });
  }
};

const handleTranslationChange = (e) => {
  const { name, value } = e.target;

  setTranslationData((prev) => ({
    ...prev,
    [name]: value,
  }));
};
const fetchMappingDetails = async () => {
  try {
    const projectID = localStorage.getItem("project_id");

    const res = await getMappingDetails(projectID);

    if (res?.data?.success) {
      const data = res.data;

      setInterimReporting(Boolean(data.interimReporting));

      if (data.translateFS && Object.keys(data.translateFS).length > 0 || data.reportingCurrency) {
        setHasTranslatedFS(true);
      } else {
        setHasTranslatedFS(false);
      }

      setFunctionalCurrency(data.currency || "");
      setPresetName(data.preset && data.preset !== "not available" ? data.preset : "");
      setCompany(data.companyName || "");
      setNatureOfCompany(data.natureOfCompany || "");
      setGaap(data.gaap || "");
      setComparativeYearLabel(data.comparativeYearLabel || "");

      setTranslationData({
        reportingCurrency: data.reportingCurrency || "",
        currentYearOpeningRate: data.translateFS?.currentYearOpeningRate ?? "",
        currentYearClosingRate: data.translateFS?.currentYearClosingRate ?? "",
        currentYearAverageRate: data.translateFS?.currentYearAverageRate ?? "",
        previousYearOpeningRate: data.translateFS?.previousYearOpeningRate ?? "",
        previousYearClosingRate: data.translateFS?.previousYearClosingRate ?? "",
        previousYearAverageRate: data.translateFS?.previousYearAverageRate ?? "",
        comparativeOpeningRate: data.translateFS?.comparativeOpeningRate ?? "",
        comparativeClosingRate: data.translateFS?.comparativeClosingRate ?? "",
        comparativeAverageRate: data.translateFS?.comparativeAverageRate ?? "",
      });

      setCurrentFinancialYear(data.currentYear || "");
      setPreviousFinancialYear(data.previousYear || "");
    }

  } catch (error) {
    console.log("Mapping fetch error", error);
  }
};
  const [deleteItemsModel, setDeleteItemsModal] = useState(false);

  let init = {
    LedgerCode: "",
    currentBalance: "",
    ledgerName: "",
    previousBalance: "",
    tbAmount: "",
  };
  const [Name, setName] = useState(init);
  const [tempID, setTempID] = useState("");

  let headers = {
    "x-auth-token": auth,
    // 'Content-Type' : 'application/json'
  };

  let vertical = "bottom";
  let horizontal = "right";

  const hiddenFileInput = React.useRef(null);

  const existFileInput = React.useRef(null);
  
  // let total_cy = 0;
  // let total_adjusted = 0;
  useEffect(() => {
    if (editTranslation) {
      fetchMappingDetails();
    }
  }, [editTranslation]);

  useEffect(() => {
    setLoading(true);
    setFilterShow(false);
    fetchUserProfile();
    fetchConvential();
    dispatch(fetchConventionalMode(project_id, TB_ID));
    setFileUpload("");
  }, [deleteRow, updateRows]);

  useEffect(() => {
    const pathname = window.location.pathname;
    const pathParts = pathname.split('/');
    if (pathParts.includes('Conventional')) {
      localStorage.setItem("templateAction", 'Conventional');
    }
  }, [])


  const fetchUserProfile = () => {
    getProfile().then(response => {
      if (response.status === 200) {
        const filtredAccessProjects =
          response.data.user.data.access_projects.filter((project) => {
            return project.project_id === projectId.pid;
          });

        if (filtredAccessProjects.length > 0) {
          setAccess(filtredAccessProjects[0]);
        } else {
          setAccess({ access: "All", project_id: "" });
        }
      }
    }).catch(error => {
      console.log("error from get profile api", error)
    })
  };

  const fetchConvential = () => {
    axios
      .get(`/api/v1/conventional-mode/fetch/${project_id}/${TB_ID}`, { headers })
      .then((response) => {
        dispatch({
          type: actionTypes.SET_TABLE_DATA,
          payload: response.data.data.line_items,
        });

        const unique = [];

        const duplicates = response.data.data.line_items.filter((o) => {
          if (unique.find((i) => i.ledger_code === o.ledger_code)) {
            return true;
          }
          unique.push(o);
          return false;
        });

        setDuplicateItems(duplicates);
        setTotalRow(response.data.data.line_items);
        setDeleteRow(false);
        setLoading(false);
        setUpdateRows(false);
      });
    const someData = tableData || [];
    const total_cy = someData.reduce((totalCy, i) => totalCy + Number(i.cy), 0);
    const total_py = someData.reduce((totalPy, i) => totalPy + Number(i.py), 0);
    const total_adjusted = someData.reduce(
      (totalPy, i) => Number(totalPy) + Number(i.adjusted_amount),
      0
    );

    return () => {
      const fd = new FormData();
      fd.append("grp", JSON.stringify(grouping.grp));
    };
  };


  function handleDrop() {
    setConfirmDelete(!confirmDelete);
  }
  useEffect(() => {
    setRender(Math.random());
  }, [grouping]);

  function handleModal() {
    uploadTb(true);
  }
  const handleClose = () => {
    uploadTb(false);
  };
  function handleApplyFilter() {
    setRender(Math.random());
    // setTotalFilter()


    if (filterData.length > 0) {
      filterData.map((filter, i) => {

        if (i === 0) {
          if (filter.column === "" && filter.change === "") {
            return;
          }
          if (
            filter.column !== "ledger_name" &&
            filter.column !== "ledger_code" &&
            filter.select === "Less than"
          ) {
            const res = (tableData || []).filter((line) => {
              if (line[`${filter.column}`] < filter.startAmount) {
                return line;
              }
            });

            setTotalFilter(res);
            return;
          }

          if (
            filter.column !== "ledger_name" &&
            filter.column !== "ledger_code" &&
            filter.select === "Greater than"
          ) {
            const res = (tableData || []).filter((line) => {
              if (line[`${filter.column}`] > Number(filter.startAmount)) {
                return line;
              }
            });

            setTotalFilter(res);
            return;
          }

          if (
            filter.column !== "ledger_name" &&
            filter.column !== "ledger_code" &&
            filter.select === "Equal to"
          ) {
            const res = (tableData || []).filter((line) => {
              if (line[`${filter.column}`] === Number(filter.startAmount)) {
                return line;
              }
            });

            setTotalFilter(res);
            return;
          }

          const res = (tableData || []).filter((line) => {
            if (
              line[`${filter.column}`]
                .toLowerCase()
                .includes(`${filter.change}`.toLowerCase())
            ) {
              return line;
            }
          });

          setTotalFilter(res);
          return;
        }
      });
    }
  }
  const head = {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "3rem",
  };

  const header = {
    fontSize: "2.2rem",
    fontWeight: "700",
  };
  const center = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const card = {
    borderRadius: "6px",
    border: "2px solid lightGrey",
    width: "13rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "8rem",
    padding: "2rem",
    cursor: "pointer",
  };

  const inputFiles = {
    borderRadius: "6px",
    border: "2px solid lightGrey",
    width: "13rem",
    height: "8rem",
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  };

  // let hideData = ""
  function groupHideItems() {
    const nextHideItems = !hideItems;
    SetHideItems(nextHideItems);
    const limit = conventionMode?.pagination?.limit || 100;
    dispatch(fetchConventionalMode(project_id, tb_id, 1, limit, conventionMode?.activeFilters, nextHideItems ? 'ungrouped' : undefined));
  }
  useEffect(() => {
    handleFetchHeader();

    const project_id = localStorage.getItem("project_id");
    axios
      .get(`/api/v1/tb-mapping/get-temp-model/${project_id}`, { headers })
      .then((response) => {
        // setinfo(dat);
      })
      .catch((error) => {
      });
  }, []);
  const handleFetchHeader = () => {
    const project_id = localStorage.getItem("project_id");
    // const temp_id = projectData[index].data.tmp_id;
    const temp_id = localStorage.getItem("temp_id");
    const auth = localStorage.getItem("auth_token");
    let headers = {
      "x-auth-token": auth,
    };

    if (!temp_id || temp_id === "undefined" || temp_id === "null") {
      console.warn("Missing temp_id, aborting API call to prevent 500 Error");
      // swal("", "Template ID is missing. Please ensure data is properly uploaded.", "error");
      return;
    }

    axios
      .get(
        `/api/v1/tb-mapping/heading-classification/${project_id}/${temp_id}`,
        { headers }
      )
      .then((response) => {
        setHeaders(response.data.headers_list);
        // setinfo(dat);
        setIndex(index);
      })
      .catch((error) => {
        console.log(error.response, "error");
      });
  };

  const handleSubmit = () => {
    let data = {
      ledger_name: Name.ledgerName,
      ledger_code: Name.LedgerCode,
      branch: Name.branchName,
      py: Name.previousBalance,
      cy: Name.currentBalance,
    };


    axios
      .post(
        `/api/v1/tb-mapping/heading-classification/${project_id}/${tempID}`,
        data,
        { headers }
      )
      .then((response) => {
        if (type === "new") {
          const auth = localStorage.getItem("auth_token");
          let headers = {
            "x-auth-token": auth,
            // "Content-Type": "multipart/form-data",
            "Content-Type": "application/json",
          };
          const project_id = localStorage.getItem("project_id");
          axios
            .post(`/api/v1/uploads/existing-tb/${project_id}/${tempID}`, data, {
              headers,
            })
            .then((response) => {
              // eliminateDupe(response.data.data.line_items);
              // setProjectData(data);
              // saveProjectData(data);
              // dispatch({
              //   type: actionTypes.SET_TABLE_DATA,
              //   payload: response.data.data.line_items,
              // });
              dispatch(fetchConventionalMode(project_id, tb_id));
              // used for refresh data BS and PNL tada of template
              dispatch(fetchTTBSData(project_id, tb_id))
              dispatch(fetchTTPNLData(project_id, tb_id))
              dispatch(fetchTTGroupData(project_id, tb_id));

              setAssignValues(false);
              setUpdateRows(true);
              // setLoading(true);
            })
            .catch((error) => {
            });
        } else {
          // setData((Data) => [...Data, fileListAsArray]);
          // setConfirm((confirm) => [...confirm, false]);
          const auth = localStorage.getItem("auth_token");
          let headers = {
            "x-auth-token": auth,
            // "Content-Type": "multipart/form-data",
            "Content-Type": "application/json",
          };
          const project_id = localStorage.getItem("project_id");
          axios
            .post(`/api/v1/uploads/merge-tb/${project_id}/${tempID}`, data, {
              headers,
            })
            .then((response) => {
              // eliminateDupe(response.data.data.line_items);
              // dispatch({
              //   type: actionTypes.SET_TABLE_DATA,
              //   payload: response.data.data.line_items,
              // });
              dispatch(fetchConventionalMode(project_id, tb_id));
              // used for refresh data BS and PNL tada of template
              dispatch(fetchTTBSData(project_id, tb_id))
              dispatch(fetchTTPNLData(project_id, tb_id))
              dispatch(fetchTTGroupData(project_id, tb_id));

              setAssignValues(false);
              setUpdateRows(true);
            })
            .catch((error) => {
            });
        }
      })
      .catch((error) => {
      });
  };

  const handleChange = (e, type) => {
    e.preventDefault();
    setType(type);
    const fileListAsArray = e.target.files;
    if (
      (fileListAsArray[0].type === "application/vnd.ms-excel") |
      (fileListAsArray[0].type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    ) {
      const auth = localStorage.getItem("auth_token");
      let headers = {
        "x-auth-token": auth,
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
      };
      const project_id = localStorage.getItem("project_id");
      const data = new FormData();
      data.append("file", fileListAsArray[0]);

      axios
        .post(`/api/v1/uploads/upload-headers/${project_id}`, data, {
          headers,
        })
        .then((response) => {

          setFileUpload(fileListAsArray);
          // setHeaders(response.data.header_list);
          setHeaders(Object.keys(response.data.result.data[0].segregatedJson));
          setTempID(response.data.tmp_id);
          setAssignValues(true);
          uploadTb(false);
        })
        .catch((error) => {
          console.log(error, "error");
        });
    }

  };

  const handleOpen = (type) => {
    uploadTb(false);
    history.push("/createproject/uploadtb");
  };


  const calculateCY = () => {
    let total = 0;

    (tableData || []).forEach((element) => {
      if (element.cy !== 0) {
        total = total + Number(element.cy);
      }
    });

    return total;
  };

  const calculatePY = () => {
    let total = 0;

    (tableData || []).forEach((element) => {
      if (element.py !== 0) {
        total = total + Number(element.py);
      }
    });

    return total;
  };

  function handleSelect(type) {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("Warning", "You have dont access to delete", "warning");
      return false;
    } else {

      if (type === "Delete Record") {
      setDeleteItemsModal(true);
      }
      setConfirmDelete(false);
    }
  }
  return (
    <>
      <ErrorPopup
        isOpen={errorData !== null}
        title={errorData?.title}
        message={errorData?.message}
        onClose={() => setErrorData(null)}
      />
      <SuccessPopup
        isOpen={showSuccessPopup}
        message={successMessage}
        onClose={() => {
          setShowSuccessPopup(false);
          setEditTranslation(false);
        }}
      />
    <div>
      {shareScreen ? (
        <ShareScreen SetShareScreen={SetShareScreen} projectid={project_id} />
      ) : null}
      {addGrouping ? (
        <AddGrouping
          setOtherGrouping={setOtherGrouping}
          newSg={newSg}
          SetMultiOptions={SetMultiOptions}
          setAddGrouping={setAddGrouping}
        />
      ) : null}
      {/* {populateFs ? <PopulateFs setPopulateFs={setPopulateFs} /> : null} */}
      {deletedMenu ? (
        <DeletedFile
          setDeleteMenu={setDeleteMenu}
          select={select}
          setUpdateRows={setUpdateRows}
        />
      ) : null}
      {addLedger ? (
        <AddLedger close={setAddLedger} name="Create a new Ledger Item" />
      ) : null}
      {expandLedger ? (
        <ExpandLedger
          close={setExpandLedger}
          name="Ledger Detail"
          select={select}
        />
      ) : null}
      {switchMode ? (
        <SwitchMode
          close={setSwitchMode}
          name="Choose a Mapping Mode"
          currentMode="1"
        />
      ) : null}
      {addLedgerAbove ? (
        <AddLedger
          close={setAddLedgerAbove}
          name="Add Ledger Above"
          select={select}
        />
      ) : null}
      {addLedgerBelow ? (
        <AddLedger
          close={setAddLedgerBelow}
          name="Add Ledger Below"
          select={select}
        />
      ) : null}
      {confirmation ? (
        <Confirmation
          setConfirmation={setConfirmation}
          confirmationMenu={confirmationMenu}
          select={select}
        />
      ) : null}

      {showAssignValues ? (
        <AssignValuesData
          show={showAssignValues}
          setShow={setAssignValues}
          info={info}
          index={index}
          setName={setName}
          Name={Name}
          // confirm={confirm}
          // setConfirm={setConfirm}
          // projectData={projectData}
          handleSubmit={handleSubmit}
          headers={headerdata}
        />
      ) : null}
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`} style={{ overflow: "hidden" }}>
          <div
            className={`${commoncss.w100} `}
            style={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}
          >
            <div className="bk-closure-tb-header" style={{ gap:"100px", flexShrink: 0 }}>
              <div className="bk-closure-tb-header-left mr-0">
                <LeftIcon
                  height={15}
                  width={15}
                  className="clickable mr-2"
                  onClick={() => {history.push(`/financialstatement/${ws_id}`)}}
                />
                <FilterIcon
                  className={commoncss.clickable}
                  onClick={() => {
                    setFilterShow(!filterShow);
                  }}
                />
                <DeleteIcon
                  className={commoncss.clickable}
                  onClick={() => multiSelectedRows_.length >= 1 && handleSelect("Delete Record")}
                />
                <span className="ml-1"
                  onClick={() => {
                    history.push("/adjustments");
                  }}><div className="toggle-container "><EditIcon
                    className={commoncss.clickable}
                    style={{ "marginTop": "3px" }}
                    width={20}
                  /><span className={`toggle-label ml-1 mt-1 ${commoncss.fs14} ${commoncss.clrGreen}`}>Adjustments</span></div>
                </span>

                <span className="ml-2 mt-1 d-inline-flex align-items-center">
                  <ToggleButton
                    label="Split mapping"
                    labelclass_="ml-1"
                    checked={checkYearly}
                    disabled={user.responsibilities === "approver" || user.responsibilities === "view"}
                    onToggle={(val) => dispatch(toggleCheckYearly(val))}
                  />
                </span>

                <span className="ml-2 mt-1 d-inline-flex align-items-center" >
                  <input
                    type="checkbox"
                    checked={hideItems}
                    onChange={() => groupHideItems()}
                    style={{ cursor: "pointer" }}
                  />
                  <span
                    className="ml-1"
                    style={{
                      fontSize: "13px",
                      fontWeight: 400,
                      color: "var(--primary-color)",
                      cursor: "pointer",
                      position: "relative",
                     // top: "2px",
                    }}
                    onClick={() => groupHideItems()}
                  >
                    Hide Grouped Items
                  </span>

                </span>
              </div>
              <div className="button-group">
                <button
                  className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                  style={{
                    borderRadius: "8.18px 0px 0px 8.18px",
                    background: "#f5f5f5",
                    height: "33px",
                  }}
                  onClick={() => {
                    sessionStorage.removeItem("view");
                    history.push(`/templateV2/${projectId.pid}`);
                  }}
                >
                  Template mode
                </button>
                <button
                  className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                  style={{
                    borderRadius: "0 8.18px 8.18px 0",
                    height: "33px",
                  }}
                >
                  Conventional mode
                </button>
              </div>
              <div className="bk-closure-tb-header-right">
                <RecycleBinIcon
                  className={`${commoncss.clickable} mr-1`}
                  onClick={() => {
                    setDeleteMenu(true);
                  }} width={22} height={25} style={{ "placeSelf": "center" }} />

                {hasTranslatedFS && (
                  <Button
                  btnColor={buttoncss.secondary}
                  class_={buttoncss.greyBg}
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <EditIcon width={15} height={15}  />
                      Edit Translation
                    </span>
                  }
                  onClick={() => {
                  setEditTranslation(true);
                  fetchMappingDetails();
                 }}
                />
                )}
                 {editTranslation && (

                  <div className={editcss.modalOverlay}>
                <div className={editcss.modalContainer}>

                  <div className={editcss.modalHeader}>
                    <span className={editcss.modalTitle}>Edit Translation</span>

                    <CloseIcon
                      className="clickable"
                      width={18}
                      height={18}
                      onClick={() => setEditTranslation(false)}
                    />
                  </div>
                  <div className={editcss.modalBody}>
                   <div className={editcss.field}>
                    <label>Select Preset</label>

                    <div className={editcss.inputWrapper}>
                      <input
                        className={editcss.inputField}
                        placeholder="Preset Name Here"
                        value={presetName}
                        onChange={(e) => setPresetName(e.target.value)}
                      />

                      <DropdownIcon className={editcss.dropdownIcon} />
                    </div>
                  </div>

               <div className={editcss.field}>
                <label>Reporting Currency</label>
                <Dropdown
                  options={[
                    { label: "INR", value: "INR" },
                    { label: "USD", value: "USD" },
                    { label: "CAD", value: "CAD" },
                    { label: "GBP", value: "GBP" },
                    { label: "EUR", value: "EUR" },
                    { label: "CHF", value: "CHF" },
                    { label: "AUD", value: "AUD" },
                    { label: "JPY", value: "JPY" },
                    { label: "SGD", value: "SGD" },
                    { label: "AED", value: "AED" },
                  ]}
                  selValue={translationData.reportingCurrency}
                  onSelect={(opt) => handleSelectCurrency(opt ? opt.value : "")}
                  placeHolder="Select Currency"
                  searchable={true}
                  disableAutoSelect={true}
                />
              </div>

                    <div className={editcss.field}>
                      <label>Company</label>
                      <input className={editcss.inputField} placeholder="Enter company name" 
                      value={company}
                      onChange={(e) => setCompany(e.target.value)}
                      />
                    </div>

                    <div className={editcss.field}>
                      <label>Nature Of Company</label>
                      <input className={editcss.inputField} placeholder="Enter nature of company" 
                      value={natureOfCompany}
                      onChange={(e) => setNatureOfCompany(e.target.value)}
                      />
                    </div>

                    {/* <div className={editcss.field}>
                      <label>Name Of The Financials</label>
                      <input className={editcss.inputField} placeholder="Financial statement Name" />
                    </div> */}

                    <div className={editcss.field}>
                      <label>Select The GAAP</label>
                      <input className={editcss.inputField} placeholder="Enter GAAP" 
                        value={gaap}
                        onChange={(e) => setGaap(e.target.value)}
                        icon={<DropdownIcon />} 
                      />
                    </div>

                   <div className={editcss.field}>
                    <label>Current Financial Year</label>
                    <div className={editcss.inputWrapper}>
                      <input className={editcss.inputField} 
                      value={currentFinancialYear ? new Date(currentFinancialYear).toISOString().split("T")[0] : ""}
                      placeholder="DD-MM-YYYY" icon={<DropdownIcon />} />

                      <CalendarIcon className={editcss.calendarIcon} />
                    </div>
                  </div>

                    <div className={editcss.field}>
                      <label>Previous Financial Year</label>

                      <div className={editcss.inputWrapper}>
                       <input className={editcss.inputField}
                        value={previousFinancialYear ? new Date(previousFinancialYear).toISOString().split("T")[0] : ""}
                       placeholder="DD-MM-YYYY" icon={<DropdownIcon />} />

                      <CalendarIcon className={editcss.calendarIcon} />
                    </div>
                    </div>

                    <div className={editcss.field}>
                      <label>Functional Currency</label>
                      <input
                        className={editcss.inputField}
                        value={functionalCurrency}
                        placeholder="Functional Currency"
                      />
                    </div>

                    {interimReporting && (
                      <div className={editcss.field}>
                        <label>Comparative Year</label>
                        <div className={editcss.inputWrapper}>
                          <input
                            className={editcss.inputField}
                            value={comparativeYearLabel}
                            placeholder="DD Month YYYY"
                            icon={<DropdownIcon />}
                          />
                          <CalendarIcon className={editcss.calendarIcon} />
                        </div>
                      </div>
                    )}

                    {/* <div className={editcss.field}>
                      <label>Select Presets/Chart Of Accounts</label>
                       <input className={editcss.inputField}  value={functionalCurrency} placeholder="Select Presets/COA" icon={<DropdownIcon />} />
                    </div> */}

                  </div>

                  <div>
                    <div className={editcss.translationSection}>
                      <span className={editcss.translationTitle}>
                        Translation information : <b style={{ color: "#2D8861" }}>USD to INR</b>
                      </span>

                      <div className={editcss.translationContainer}>
                        <table className={editcss.translationTable}>
                          <thead>
                            <tr>
                              <th style={{ textAlign: "left" }}>DATE</th>
                              <th style={{ textAlign: "right" }}>OPENING RATE</th>
                              <th style={{ textAlign: "right" }}>CLOSING RATE</th>
                              <th style={{ textAlign: "right" }}>AVERAGE RATE</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                            <td style={{ textAlign: "left" }}>Current Year</td>

                            <td style={{ textAlign: "right" }}>
                            <input
                            type="number"
                            name="currentYearOpeningRate"
                            value={translationData.currentYearOpeningRate}
                            onChange={handleTranslationChange}
                            style={{ textAlign: "right" }}
                            />
                            </td>

                            <td style={{ textAlign: "right" }}>
                            <input
                            type="number"
                            name="currentYearClosingRate"
                            value={translationData.currentYearClosingRate}
                            onChange={handleTranslationChange}
                            style={{ textAlign: "right" }}
                            />
                            </td>

                            <td style={{ textAlign: "right" }}>
                            <input
                            type="number"
                            name="currentYearAverageRate"
                            value={translationData.currentYearAverageRate}
                            onChange={handleTranslationChange}
                            style={{ textAlign: "right" }}
                            />
                            </td>
                            </tr>

                            <tr>
                            <td style={{ textAlign: "left" }}>Previous Year</td>

                            <td style={{ textAlign: "right" }}>
                            <input
                            type="number"
                            name="previousYearOpeningRate"
                            value={translationData.previousYearOpeningRate}
                            onChange={handleTranslationChange}
                            style={{ textAlign: "right" }}
                            />
                            </td>

                            <td style={{ textAlign: "right" }}>
                            <input
                            type="number"
                            name="previousYearClosingRate"
                            value={translationData.previousYearClosingRate}
                            onChange={handleTranslationChange}
                            style={{ textAlign: "right" }}
                            />
                            </td>

                            <td style={{ textAlign: "right" }}>
                            <input
                            type="number"
                            name="previousYearAverageRate"
                            value={translationData.previousYearAverageRate}
                            onChange={handleTranslationChange}
                            style={{ textAlign: "right" }}
                            />
                            </td>
                            </tr>

                            {interimReporting && (
                              <tr>
                                <td style={{ textAlign: "left" }}>Comparative Period</td>

                                <td style={{ textAlign: "right" }}>
                                <input
                                type="number"
                                name="comparativeOpeningRate"
                                value={translationData.comparativeOpeningRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                                />
                                </td>

                                <td style={{ textAlign: "right" }}>
                                <input
                                type="number"
                                name="comparativeClosingRate"
                                value={translationData.comparativeClosingRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                                />
                                </td>

                                <td style={{ textAlign: "right" }}>
                                <input
                                type="number"
                                name="comparativeAverageRate"
                                value={translationData.comparativeAverageRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                                />
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>

                  <div className={editcss.modalFooter}>
                   <Button
                    btnColor={buttoncss.primary}
                    label="Save Changes"
                    onClick={handleSaveTranslation}
                  />
                  </div>

                </div>
                  </div>
                )}
                <Button
                  btnColor={buttoncss.secondary}
                  class_={buttoncss.greyBg}
                  label="Upload TB"
                  onClick={() => user.responsibilities === "approver" || user.responsibilities === "view" ? null : uploadTb(true)}
                />
                {hasTranslatedFS && (
                <Button
                  btnColor={buttoncss.secondary}
                  class_={buttoncss.greyBg}
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <ExportIcon width={15} height={15} />
                      Export
                    </span>
                  }
                  onClick={handleExportTranslation}
                />
              )}
                <Button
                  btnColor={buttoncss.primary}
                  label="Populate FS"
                  onClick={() => history.push("/preview")}
                />
              </div>
            </div>

            {loading && (
              <div
                style={{
                  height: "80vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spinner animation="grow" size="sm" />
                <Spinner animation="grow" style={{ margin: "1rem" }} />
                <Spinner animation="grow" size="sm" />
              </div>
            )}
            {!loading && (
               <div
                  style={{
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    overflowX: "auto",
                    paddingBottom: "10px",
                  }}
                >
              <BasicTable
                interimReporting={interimReporting}
                multiOptions={multiOptions}
                otherGrouping={otherGrouping}
                SetNewSg={SetNewSg}
                setAddGrouping={setAddGrouping}
                totalFilter={totalFilter}
                hideItems={hideItems}
                setTotalRow={setTotalRow}
                setSelect={setSelect}
                loading={loading}
                setLoading={setLoading}
                filterShow={filterShow}
                // tableData={someData}
                SetHideItems={SetHideItems}
                hiddenFilter={hiddenFilter}
                fetchConvential={setUpdateRows}
                setUpdateTabs={setUpdateTabs}
                getdata={getDataCount}
                filterEnable={filterEnable}
              />
            </div>
            )}
          </div>

        </div>
        <Filter
          show={filterShow}
          handleApplyFilter={handleApplyFilter}
          setFilterShow={setFilterShow}
          setObject={setObject}
          setFilterRow={setFilterRow}
          filterRow={filterRow}
          SetConfirmFilClose={SetConfirmFilClose}
          filterEnable={filterEnable}
          filterHandler={setFilterEnable}
          hideItems={hideItems}
        />
        {confirmDelete ? (
          <DeleteSelected
            setDeleteRow={setDeleteRow}
            fetchConvential={fetchConvential}
            setConfirmDelete={setConfirmDelete}
            select={select}
            setConfirmation={setConfirmation}
            setConfirmationMenu={setConfirmationMenu}
            setExpandLedger={setExpandLedger}
            setAddLedgerBelow={setAddLedgerBelow}
            setAddLedgerAbove={setAddLedgerAbove}
          />
        ) : null}


      </div>

      {openDuplicateModal && (
        <DeleteDuplicate
          duplicateItems={duplicateItems}
          openDuplicateModal={openDuplicateModal}
          setDuplicateModal={setDuplicateModal}
          calculateCY={calculateCY}
          calculatePY={calculatePY}
          fetchConvential={setUpdateRows}
        />
      )}
      {tb_upload && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "500px",
              background: "#FFFFFF",
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            }}
          >
            {/* Header */}
            <div
              style={{
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 20px",
                borderBottom: "1px solid #EAEEED",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <LeftIcon
                  width={14}
                  height={14}
                  className="clickable"
                  onClick={() => uploadTb(false)}
                />

                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: 500,
                    color: "#202124",
                  }}
                >
                  Upload Trial Balance (Excel)
                </span>
              </div>

              <CloseIcon
                width={16}
                height={16}
                className="clickable"
                onClick={() => uploadTb(false)}
              />
            </div>

            {/* Body */}
            <div
              style={{
                padding: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                }}
              >
                {/* Existing TB Upload */}
                <div
                  onClick={() => handleOpen("existing")}
                  style={{
                    flex: 1,
                    height: "160px",
                    border: "1px solid #DDE7DE",
                    borderRadius: "16px",
                    overflow: "hidden",
                    cursor: "pointer",
                    background: "#FFFFFF",
                  }}
                >
                  <div
                    style={{
                      height: "115px",
                      background: "#FFFFFF",
                    }}
                  />

                  <div
                    style={{
                      height: "45px",
                      background: "#F4F8F5",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "16px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#202124",
                    }}
                  >
                    Existing TB Upload
                  </div>
                </div>

                {/* New TB Upload */}
                <div
                  onClick={() => handleOpen("new")}
                  style={{
                    flex: 1,
                    height: "160px",
                    border: "1px solid #DDE7DE",
                    borderRadius: "16px",
                    overflow: "hidden",
                    cursor: "pointer",
                    background: "#FFFFFF",
                  }}
                >
                  <div
                    style={{
                      height: "115px",
                      background: "#FFFFFF",
                    }}
                  />

                  <div
                    style={{
                      height: "45px",
                      background: "#F4F8F5",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "16px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#202124",
                    }}
                  >
                    New TB Upload
                  </div>
                </div>
              </div>

              <div
                style={{
                  marginTop: "12px",
                  fontSize: "12px",
                  color: "#666666",
                }}
              >
                Make sure only one sheet is present if one file is uploaded at a time
              </div>
            </div>
          </div>
        </div>
      )}
       {deleteItemsModel && (<Modal
                      headerActions={
                        <CloseIcon
                          onClick={() => {
                            // handleClose();
                            setDeleteItemsModal(false);
                          }}
                          className="clickable"
                        />
                      }
                      headerBottomLine={false}
                      onClose={() => console.log("Modal Closed")}
                    >
                      <span className={`${modalcss.modalBodyHead} mb-1`}>
                        Do you want to <span className="fw700">delete </span>
                        selected items?
                      </span>
                      <span
                        className={`${modalcss.modalBodycnt}`}
                        style={{ "marginBottom": "35px" }}
                      >
                        Once deleted, you can restore using the bin
                      </span>
                      <span
                        className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
                      >
                        <Button
                          btnColor={buttoncss.danger}
                          label="Delete"
                          icon={<DeleteIconWhite width={20} height={20} />}
                          onClick={() => {
                          
                            let row = multiSelectedRows_;
                            const auth = localStorage.getItem("auth_token");
                            const project_id = localStorage.getItem("project_id");
                            let headers = {
                              "x-auth-token": auth,
                              // 'Content-Type' : 'application/json'
                            };

                            axios
                              .delete(`/api/v1/conventional-mode/delete/${project_id}`, {
                                headers: headers,
                                data: { row },
                              })
                              .then((response) => {

                                setDeleteRow(true);
                                dispatch(fetchConventionalMode(project_id, TB_ID));
                                dispatch(deleteLineItems(row, project_id, TB_ID));
                                setSuccessMessage("Deleted successfully");
                                setShowSuccessPopup(true);
                                setTimeout(() => setShowSuccessPopup(false), 2000);
                              })
                              .catch((error) => {
                                console.log(error.response, "error");
                              });
                            setDeleteItemsModal(false);
                          }}
      
                        />
                        <Button
                          btnColor={buttoncss.secondary_del}
                          label="Cancel"
                          onClick={() => {
                            // handleClose();
                            setDeleteItemsModal(false);
                          }}
                        />
                      </span>
                    </Modal>
                    )}
    </div>
    </>
  );
};

export default Conventional;